import styles from "./Table.module.css";
import { FunctionComponent, PropsWithChildren } from "react";
import classNames from "classnames";

const Table: FunctionComponent<PropsWithChildren<{}>> = ({ children }) => (
  <table className={styles.table}>{children}</table>
);

type TTableCellProps = {
  type: "header" | "key" | "value";
  className?: string;
};

const TableCell: FunctionComponent<PropsWithChildren<TTableCellProps>> = (
  props
) => (
  <td
    className={classNames(
      styles.cell,
      {
        [styles.header]: props.type === "header",
        [styles.key]: props.type === "key",
        [styles.value]: props.type === "value",
      },
      props.className
    )}
  >
    {props.children}
  </td>
);

export { TableCell };
export default Table;
